/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Detail_Remove_User_ConfirmInputs */

const en_admin_company_detail_remove_user_confirm = /** @type {(inputs: Admin_Company_Detail_Remove_User_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const de_admin_company_detail_remove_user_confirm = /** @type {(inputs: Admin_Company_Detail_Remove_User_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Admin_Company_Detail_Remove_User_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_detail_remove_user_confirm = /** @type {((inputs?: Admin_Company_Detail_Remove_User_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Detail_Remove_User_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_detail_remove_user_confirm(inputs)
	return en_admin_company_detail_remove_user_confirm(inputs)
});